import axios from 'axios'
import { Toast } from 'vant';
import router from '@/router'
import {clearUserInfo} from '@/utils/utils'
import androidinfo from '@/utils/androidinfo'


function getToken () {
  return localStorage.getItem('token')
}
function getOfficeToken () {
  return localStorage.getItem('internalOfficeToken')
}
const service = axios.create()
// 请求拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code == 1000) {
      clearUserInfo()
      router.replace('/login')
      try {
        androidinfo.clearAllHistory()
      } catch (error) {
        
      }
    }
    return response
  },
  error => {
    if (error.response) {
      errorHandler(error)
    } else {
      Toast('请求失败')
    }
  }
)

function errorHandler (error) {
  Toast(error.message)
}

/**
 * @method 发送post请求
 * @param {String} url 请求连接
 * @param {Object} params 请求参数
 */
function fetchPost (url, params) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: 'post',
      data: JSON.stringify(params),
      timeout: 1000 * 60,
      headers: {
        'token': getToken(),
        'Internalofficepctoken': getOfficeToken(),
        'Content-Type': 'application/json;charset=utf-8'
      }
    }).then(res => {
      resolve(res.data);
    }).catch((error) => {
      reject(error)
    })
  })
}

/**
 * @method 发送post请求
 * @param {String} url 请求连接
 * @param {Object} params 请求参数
 */
function fetchPostNoToken (url, params) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: 'post',
      data: JSON.stringify(params),
      timeout: 1000 * 60,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    }).then(res => {
      resolve(res.data);
    }).catch((error) => {
      reject(error)
    })
  })
}

/**
 * @method 发送get请求
 * @param {String} url 请求连接
 */
function fetchGet (url) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "get",
      timeout: 1000 * 60,
      headers: {
        'token': getToken(),
        'Internalofficepctoken': getOfficeToken(),
        'Content-Type': 'application/json;charset=utf-8',
        'Cache-Control': 'no-cache'//清除缓存---针对ie浏览器
      }
    }).then(res => {
      resolve(res.data);
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * @method 发送get请求
 * @param {String} url 请求连接
 */
function fetchGetNoToken (url) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: "get",
      timeout: 1000 * 60,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'Cache-Control': 'no-cache'//清除缓存---针对ie浏览器
      }
    }).then(res => {
      resolve(res.data);
    }).catch(error => {
      reject(error)
    })
  })
}


/**
 * @method post请求,上传文件
 * @param {*} url 
 * @param {*} params 
 * @returns 
 */
function fetchUpLoad (url, params) {
  let formData = new FormData();
  formData.append("file", params);
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'token': getToken(),
        'content-type': 'multipart/form-data',
        'Internalofficepctoken': getOfficeToken()
      }
    }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err)
      })
  });
}

/**
 * @method post请求,上传文件
 * @param {*} url 必填
 * @param {*} file 必填
 * @param {*} type 必填
 * @param {*} remark 非必填 
 * @returns 
 */
function fetchUpLoad1 (url, file, type, remark) {
  let formData = new FormData();
  formData.append("file", file);
  if (type) {
    formData.append("type", type);
  }
  if (remark) {
    formData.append("remark", remark);
  }
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'token': getToken(),
        'content-type': 'multipart/form-data',
        'Internalofficepctoken': getOfficeToken()
      }
    }).then(res => {
      resolve(res.data);
    })
      .catch(err => {
        reject(err)
      })
  });
}

/**
 * @method put请求
 * @param {*} url 
 * @param {*} params 
 * @returns 
 */
function fetchPut (url, params) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: 'put',
      data: params,
      timeout: 1000 * 60,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'token': getToken(),
        'Internalofficepctoken': getOfficeToken()
      }
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err)
    })
  });
}

/**
 * @method put请求
 * @param {*} url 
 * @param {*} params 
 * @returns 
 */
 function fetchPutNoToken (url, params) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: 'put',
      data: params,
      timeout: 1000 * 60,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      }
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err)
    })
  });
}

/**
 * @method delete请求
 * @param {*} url 
 * @param {*} params 
 * @returns 
 */
function fetchDelete (url, params) {
  return new Promise((resolve, reject) => {
    service({
      url: url,
      method: 'delete',
      data: params,
      timeout: 1000 * 60,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        'token': getToken(),
        'Internalofficepctoken': getOfficeToken()
      }
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err)
    })
  });
}

export default {
  fetchPost,
  fetchPostNoToken,
  fetchGet,
  fetchGetNoToken,
  fetchUpLoad,
  fetchPut,
  fetchPutNoToken,
  fetchDelete,
  fetchUpLoad1
}




// WEBPACK FOOTER //
// ./src/request/http.js